import { FormSection } from '@portals-platform/ui-forms';
import type { ReactNode } from 'react';

interface CertificateSectionProps {
  title: string;
  description?: string | undefined;
  children: ReactNode;
}

export function CertificateSection({ title, description, children }: CertificateSectionProps) {
  return (
    <div className="overflow-hidden rounded-[var(--radius-lg)] border border-border bg-card">
      <FormSection
        title={title}
        className="md:[&>div:first-child]:grid-cols-[40%_1fr]"
        {...(description !== undefined && { description })}
      >
        {children}
      </FormSection>
    </div>
  );
}
